<div class="cv-panel-header action-toggle"
	[ngClass]="'bg-'+class"
	(click)="togglePanel($event)">
	<div class="row mt-1">
		<div class="col-sm-6">
			<span class="cv-panel-header__title"
				[ngClass]="getTextClass()">
				{{ title }}
			</span>
			<div class="d-inline mr-3" *ngIf="leftButtons && leftButtons.length > 0">
				<button *ngFor="let actionButton of leftButtons"
					#actionButtons 
					class="btn header-action-button"
					[ngClass]="actionButton.class"
					[disabled]="(actionButton.disabled !== undefined && actionButton.disabled())"
					(click)="onButtonClick($event, actionButton)">
					
					<span *ngIf="!actionButton.loading || !actionButton.loading()">
						<i *ngIf="actionButton.icon" class="fa" [ngClass]="actionButton.icon"></i>
						<span>{{actionButton.text}}</span>
					</span>
					<span *ngIf="(actionButton.loading && actionButton.loading())">
						<cv-loader></cv-loader>
						<span class="ml-1">{{actionButton.loadingText || 'Loading'}}</span>
					</span>
				</button>
			</div>
		</div>
		<div class="col-sm-6 text-right">
			<div class="d-inline mr-2" *ngIf="rightButtons && rightButtons.length > 0">
				<button *ngFor="let actionButton of rightButtons"
						#actionButtons 
						class="btn header-action-button"
						[ngClass]="actionButton.class"
						[disabled]="(actionButton.disabled !== undefined && actionButton.disabled())"
						(click)="onButtonClick($event, actionButton)">
					<span *ngIf="!actionButton.loading || !actionButton.loading()">
						<i *ngIf="actionButton.icon" class="fa" [ngClass]="actionButton.icon"></i>
						<span>{{actionButton.text}}</span>
					</span>
					<span *ngIf="(actionButton.loading && actionButton.loading())">
						<cv-loader></cv-loader>
						<span class="ml-1">{{actionButton.loadingText || 'Loading'}}</span>
					</span>
				</button>
			</div>
			<div class="d-inline-flex align-items-center" [ngClass]="getTextClass()">
				<i *ngIf="isExpandable"
					(click)="onExpand()"
					[ngClass]="{
						 'fa-expand-arrows-alt': !isExpanded,
				 		 'fa-compress-arrows-alt': isExpanded
					}"
					class="header-action-button expand-button fas">
				</i>
				<span class="cv-panel-header__indicator"
							[ngClass]="getTextClass()"
							[@indicatorMove]="state">
			</span>
			</div>
		</div>
	</div>
</div>
<div class="cv-panel-content"
	[ngClass]="{'remove-borders': getTextClass() === 'text-light'}">
	<div class="cv-panel-content__body"
		[@panelExpation]="state"
		[ngClass]="'bg-'+class">
		<ng-content></ng-content>
	</div>
</div>
